import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CapacityBarProps {
  usedWeightT: number;
  maxWeightT: number;
  usedLengthM: number;
  maxLengthM: number;
}

const CapacityBar: React.FC<CapacityBarProps> = ({usedWeightT, maxWeightT, usedLengthM, maxLengthM}) => {
  const {t} = useTranslation();
  const weightPct = maxWeightT > 0 ? Math.min((usedWeightT / maxWeightT) * 100, 100) : 0;
  const lengthPct = maxLengthM > 0 ? Math.min((usedLengthM / maxLengthM) * 100, 100) : 0;

  const barColor = (pct: number): 'success' | 'warning' | 'error' => {
    if(pct >= 90) return 'error';
    if(pct >= 70) return 'warning';
    return 'success';
  };

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
      <Box>
        <Box sx={{display: 'flex', justifyContent: 'space-between', mb: 0.5}}>
          <Typography variant="caption" color="text.secondary">{t('Weight')}</Typography>
          <Typography variant="caption" fontWeight={600}>
            {usedWeightT.toFixed(1)}T / {maxWeightT.toFixed(1)}T
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={weightPct}
          color={barColor(weightPct)}
          sx={{height: 8, borderRadius: 4}}
        />
      </Box>
      <Box>
        <Box sx={{display: 'flex', justifyContent: 'space-between', mb: 0.5}}>
          <Typography variant="caption" color="text.secondary">{t('Length')}</Typography>
          <Typography variant="caption" fontWeight={600}>
            {usedLengthM.toFixed(1)}m / {maxLengthM.toFixed(1)}m
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={lengthPct}
          color={barColor(lengthPct)}
          sx={{height: 8, borderRadius: 4}}
        />
      </Box>
    </Box>
  );
};

export default CapacityBar;
